module.exports = __webpack_public_path__ + "media/assets/certification_page/unit-icon-5822d1e47fd2aa94142342e04e9263be188dcd0f66cec5141914ab50e317d83d.svg";